import { connect } from 'react-redux';
import { getWatchCount } from '../../../publicSession/selectors';
const mapStateToProps = (state)=>({
        watchCount: getWatchCount(state)
    });
const mapDispatchToProps = {};
export default connect(mapStateToProps, mapDispatchToProps);
